<template>
	<FlowTreeVirtualBlockDataProvider :placement="elementPlacement" />
</template>

<script>
import FlowTreeMixin from './FlowTreeMixin';
import FlowTreeVirtualBlockDataProvider from './FlowTreeBlock/FlowTreeVirtualBlockDataProvider.vue';
export default {
	name: 'FlowContextualActionVirtualNode',
	components: { FlowTreeVirtualBlockDataProvider },
	mixins: [FlowTreeMixin],
};
</script>
<style scoped lang="scss"></style>
